import { Box, Container as MuiContainer } from "@mui/material";
import merge from "lodash-es/merge";
import React from "react";
export const Container = ({ children, sx, ...boxProps }) => {
    const baseStyles = {
        pt: { xs: 8, sm: 10, md: 12, xl: 14 },
        pb: { xs: 8, sm: 10, md: 12, xl: 14 },
    };
    const mergedStyles = sx ? merge(baseStyles, sx) : baseStyles;
    return (React.createElement(Box, { sx: mergedStyles, ...boxProps },
        React.createElement(MuiContainer, null, children)));
};
//# sourceMappingURL=container.js.map